/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    variants: {
        webTextArea: (props) => ({
            ...(props?.theme?.textStyles?.bodyMdRegular || {}),
            width: '100%',
            minHeight: '120px',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderRadius: 0,
            borderColor: 'webTheme.strokeSecondary',
            paddingLeft: 2,
            paddingRight: 2,
            paddingTop: '22px',
            paddingBottom: '4px',
            bg: 'webTheme.fieldDefault',
            color: 'webTypo.textPrimary',
            resize: 'vertical',
            _placeholder: {
                color: 'transparent'
            },
            _hover: {
                borderColor: 'webTheme.strokeSecondary'
            },
            _focusVisible: {
                borderColor: 'webTheme.strokeInteractive',
                boxShadow: '0 0 0 1px var(--chakra-colors-webTheme-strokeInteractive)'
            },
            _invalid: {
                borderColor: 'webTheme.supportError',
                boxShadow: 'none',
                _focusVisible: {
                    borderColor: 'webTheme.supportError',
                    boxShadow: '0 0 0 1px var(--chakra-colors-webTheme-supportError)'
                }
            },
            _disabled: {
                opacity: 1,
                bg: 'webTheme.fieldDisabled',
                borderColor: 'webTypo.textDisabled',
                color: 'webTypo.textDisabled',
                cursor: 'not-allowed',
                _hover: {
                    borderColor: 'webTypo.textDisabled'
                }
            }
        })
    }
}
